import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  menuList: null,
  subCategoryList: null,
  subSubCategoryList: null,
  selectedCategory: null,
  IsShowSubCategoryBox: null,
  parentCategory: null,
  selectedSubCategory: null,
  isEditSubCategory: null,
  subParentCategory: null,
  IsSetShowAllSubCategories:null,
  IsParentLoader:false
};

export const apiSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    reduxMenuList: (state, action) => {
      
      state.menuList = action.payload;
    },
    reduxSubCategoryList: (state, action) => {
      state.subCategoryList = action.payload;
    },
    reduxSubSubCategoryList: (state, action) => {
      state.subSubCategoryList = action.payload;
    },
    reduxSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
    reduxSelectedSubCategory: (state, action) => {
      state.selectedSubCategory = action.payload;
    },
    reduxParentCategory: (state, action) => {
      state.parentCategory = action.payload;
    },
    reduxSubParentCategory: (state, action) => {
      state.subParentCategory = action.payload;
    },
    reduxIsShowSubCategoryBox: (state, action) => {
      state.IsShowSubCategoryBox = action.payload;
    },
    reduxIsSetShowAllSubCategories: (state, action) => {
      state.IsSetShowAllSubCategories = action.payload;
    },
    reduxIsEditSubCategory: (state, action) => {
      state.isEditSubCategory = action.payload;
    },
    reduxIsParentLoader: (state, action) => {
      state.IsParentLoader = action.payload;
    },
    
  },
});

export const { reduxMenuList, reduxSubSubCategoryList,reduxIsSetShowAllSubCategories,reduxSubParentCategory,reduxIsEditSubCategory,reduxSubCategoryList,reduxSelectedSubCategory,reduxSelectedCategory,reduxIsShowSubCategoryBox,reduxParentCategory,reduxIsParentLoader } = apiSlice.actions;
export default apiSlice.reducer;
